import { createFileRoute, redirect } from "@tanstack/react-router";

import { requireAuthenticated } from "../router/auth";

export const Route = createFileRoute("/$")({
  beforeLoad: async ({ context, location, abortController }) => {
    await requireAuthenticated(context.auth, location, abortController.signal);
    throw redirect({ to: "/", replace: true });
  },
});
